<template>
  <vx-card class="stats-card">
    <div v-if="dataPrepared">
      <vue-apex-charts key="real-one" height="200" :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
    </div>

    <div v-else>
      <vue-apex-charts key="placehodler" height="200" :options="lineChartSimple.chartOptions" :series="[]"></vue-apex-charts>
    </div>
  </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'
import * as DateHelper from '@/helpers/date'

export default {
  components: {
    VueApexCharts
  },
  props: ['from', 'to'],
  data () {
    return {
    daysRange: null,
    dataPrepared: false,
    lineChartSimple: {
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          },
          stroke: {
            width: 1
          },
          zoom: {
            enabled: true
          },
          type: 'histogram',
          stacked: true,
        },
        colors: [],
        noData: {
          text: "loading...",
          align: 'center',
          verticalAlign: 'top',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: 'gray',
            fontSize: '32px',
            fontFamily: undefined
          }
        },
        dataLabels: {
          enabled: false
        },
        // markers: {
        //   size: 5,
        //   colors: ["#000524"],
        //   strokeColor: "#00BAEC",
        //   strokeWidth: 3
        // },
        stroke: {
          curve: 'smooth'
        },
        tooltip: {
          x: {
            show: false,
          }
          // enabled: true
        },
        fill: {
           gradient: {
            enabled: true,
            opacityFrom: 0.5,
            opacityTo: 0
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            formatter: (value) => Math.floor(value)
          },
        },
      }
    }
  }
  },
  watch: {
    to: {
      immediate: true,
      async handler (to) {
        console.log('handler to', to)
        if (!to) return

        this.dataPrepared = false

        this.daysRange = _.range(
          Math.abs(DateHelper.datesDiff(this.from, DateHelper.midnight())),
          Math.abs(DateHelper.datesDiff(this.to, DateHelper.midnight())) - 1,
          -1
        )

        console.log('daysRange', this.daysRange)

        this.lineChartSimple.chartOptions.xaxis.categories = _.map(this.daysRange, (dayAgo) => {
          const date = DateHelper.addDays(DateHelper.midnight(), -dayAgo)

          if (this.daysRange.length > 10) {
            return (dayAgo % 8 === 0 ? this.$options.filters.dateWord(date) : '')
          } else {
            return this.$options.filters.weekDayShort(date)
          }
        })

        setTimeout( () => this.loadData(), 1000)
      }
    },
  },
  mounted () {
    console.log('stats mounted')
    // this.loadData()
  },
  methods: {
    loadData () {
      if (this.$store.getters.allDataLoaded) {
        this.$store.dispatch('computeStatsData', { daysRange: this.daysRange }).then(
        ({ series, colors}) => {
          this.lineChartSimple.series = series
          this.lineChartSimple.chartOptions.colors = _.map(colors, (c) => { return (c ? c : '#dae1e7') })
          this.dataPrepared = true

          if (series.length < 1) {
            this.lineChartSimple.chartOptions.noData.text = ""
            }
          }
        )
      } else {
        setTimeout( () => this.loadData(), 1000)
      }

    }
  },
  computed: {
    registeredDaysAgo () {
      return DateHelper.datesDiff(DateHelper.midnight(), DateHelper.midnight(this.$store.getters.userRegisteredAt))
    },


  },
}
</script>

<style lang="scss">

.stats-card {
  .vx-card__body {
    padding: 2rem 0.8rem 0 0.8rem !important
  }
}

</style>
